import type { QueryClient } from '@tanstack/react-query';

/** Prefix matches useApproveRequest / useRejectRequest, which invalidate ['approvals']. */
export const reviewQueueKey = ['approvals', 'mine'] as const;

export function invalidateReviewQueue(queryClient: QueryClient) {
  void queryClient.invalidateQueries({ queryKey: reviewQueueKey });
}
